import {styled} from '@mui/material/styles';

import {ChevronRight} from 'assets/icons/chevronRight';
import PinDrop from 'assets/icons/pinDrop';

export const StyledPinDrop = styled(PinDrop)({fontSize: 18});
export const StyledChevronRight = styled(ChevronRight)({color: 'black', fontWeight: 'bold'});
